import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const TicketRepository = {
  get: (id) => {
    return Axios.get(`${SETTINGS.API_URL}ticket/${id}`);
  },

  getLifeCycle: (id) => {
    return Axios.get(`${SETTINGS.API_URL}ticket/${id}/lifecycle`);
  },

  getCommunication: (id) => {
    return Axios.get(`${SETTINGS.API_URL}ticket/${id}/communication`);
  },

  createMessage: (data) => {
    return Axios.post(`${SETTINGS.API_URL}ticket/message`, data);
  },

  createMessageWithAttachment: (data, chatDocument) => {
    const formData = new FormData();
    formData.append("message", JSON.stringify(data));
    formData.append("chatDocument", chatDocument);

    return Axios({
      url: `${SETTINGS.API_URL}ticket/messageWithAttachment`,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });
  },

  getAllMessageAttachments: (ticketId) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket/getAllMessageAttachments/${ticketId}`,
      method: "GET",
    });
  },

  getAll: (
    page,
    size,
    filterParams,
    orderBy = "dateCreated",
    orderDirection = "DESC"
  ) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket`,
      method: "GET",
      params: {
        page: page,
        size: size,
        filterParams: filterParams,
        orderBy: orderBy,
        orderDirection: orderDirection,
      },
    });
  },

  getAllWithoutPaging: (filterParams) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket/allWithoutPaging`,
      method: "GET",
      params: {
        filterParams: filterParams,
      },
    });
  },

  getByTicketNumber: (ticketNumber) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket/number/${ticketNumber}`,
    });
  },

  create: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket`,
      method: "POST",
      data: data,
    });
  },

  mostBookedDestinations: (
    size,
    filterParams,
    orderBy = "dateCreated",
    orderDirection = "DESC"
  ) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket/mostBookedDestinations`,
      method: "GET",
      params: {
        size: size,
        filterParams: filterParams,
        orderBy: orderBy,
        orderDirection: orderDirection,
      },
    });
  },

  getAllTicketStatuses: () => {
    return Axios({
      url: SETTINGS.API_URL + "ticket/ticketStatuses",
      method: "GET",
    });
  },

  getAvailableDeparturesOneFormTicket: (oneFormTicketDTO) => {
    return Axios({
      url: `${SETTINGS.API_URL}product/getAvailableDeparturesOneFormTicket`,
      method: "POST",
      data: oneFormTicketDTO,
    });
  },

  notifyEpayForTicket: (customerReferenceNumber, status, brn) => {
    return Axios({
      url: `https://epay.astaadria.com/changedfromoutside`,
      method: "GET",
      params: {
        id: customerReferenceNumber,
        status: status,
        brn: brn,
      },
    });
  },

  getAllMessages: (page, size) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket/allMessages`,
      method: "GET",
      params: {
        page: page,
        size: size,
      },
    });
  },

  grandTotalPricesForAllTickets: (
    page,
    size,
    filterParams,
    orderBy = "dateCreated",
    orderDirection = "DESC"
  ) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket/grandTotalPricesForAllTickets`,
      method: "GET",
      params: {
        page: page,
        size: size,
        filterParams: filterParams,
        orderBy: orderBy,
        orderDirection: orderDirection,
      },
    });
  },

  checkDuplicateTickets: (ticket) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket/checkDuplicateTickets`,
      method: "PUT",
      data: ticket,
    });
  },

  checkDuplicateTicketsComplex: (departureDays, truckPlateNumber) => {
    return Axios({
      url: `${SETTINGS.API_URL}ticket/checkDuplicateTicketsComplex`,
      method: "PUT",
      data: departureDays,
      params: {
        truckPlateNumber: truckPlateNumber,
      },
    });
  },
};
